var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentimentAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11C7.07008 11.6072 7.97771 12 9 12C9.34973 12 9.68604 11.954 10 11.8692",
    stroke: "#151419",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5V7.25",
    stroke: "#151419",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.5V7.25",
    stroke: "#151419",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.5265 2 15.4439 4.60771 15.9291 8",
    stroke: "#151419",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10C13.6863 10 11 12.6863 11 16C11 19.3137 13.6863 22 17 22C20.3137 22 23 19.3137 23 16C23 12.6863 20.3137 10 17 10ZM18.8005 19.4504C19.0492 19.7816 19.5194 19.8484 19.8506 19.5997C20.1818 19.3509 20.2486 18.8808 19.9998 18.5496C19.3169 17.6404 18.2273 17.05 16.9999 17.05C15.7726 17.05 14.6829 17.6404 14 18.5496C13.7513 18.8808 13.8181 19.3509 14.1493 19.5997C14.4805 19.8484 14.9506 19.7816 15.1994 19.4504C15.6111 18.9022 16.2643 18.55 16.9999 18.55C17.7356 18.55 18.3887 18.9022 18.8005 19.4504ZM14.75 13.75C15.1642 13.75 15.5 14.0858 15.5 14.5V14.875C15.5 15.2892 15.1642 15.625 14.75 15.625C14.3358 15.625 14 15.2892 14 14.875V14.5C14 14.0858 14.3358 13.75 14.75 13.75ZM20 14.5C20 14.0858 19.6642 13.75 19.25 13.75C18.8358 13.75 18.5 14.0858 18.5 14.5V14.875C18.5 15.2892 18.8358 15.625 19.25 15.625C19.6642 15.625 20 15.2892 20 14.875V14.5Z",
    fill: "#151419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentAnalysis);
export default __webpack_public_path__ + "static/media/sentimentAnalysis.dd2049f01fc040dc20155e2df1e95838.svg";
export { ForwardRef as ReactComponent };